var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.authenticated)?_c('MainLayout',[_c('App',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading.global),expression:"loading.global"}]})],1):_c('LoginLayout',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading.global),expression:"loading.global"}]},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }